import type { RouteRecordName } from '#vue-router'
import { PAGE_ROUTE_NAMES } from '@/constants/route'

export function checkIfFunkiPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('funki')
}

export function checkIfContactPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('contact')
}

export function checkIfOrderListPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('orders-list')
}

export function checkIfOrderDetailPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('orders-info-order_id')
}

export function checkIfAttendeeFormPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('form-attendee-order-order_id')
}

export function checkIfBookingIndexPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('booking-id_')
}

export function checkIfFunBookBookingIndexPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('funbook-branch_id-booking-product_id_')
}

export function checkIfBookingPreviewPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('booking-id-preview')
}

export function checkIfRegionCategoriesPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().includes(PAGE_ROUTE_NAMES.REGION_CATEGORIES)
}

export function checkIfRegionThemesPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().includes(PAGE_ROUTE_NAMES.REGION_THEMES)
}

export function checkIfRegionSearchPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().includes(PAGE_ROUTE_NAMES.REGION_SEARCH)
}

export function checkIfRegionTagPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().includes(PAGE_ROUTE_NAMES.REGION_TAG)
}

export function checkIfSubCategoryPage(routeName?: RouteRecordName | null, query?: Record<string, unknown>) {
  const hasSourceCategoryId = query && 'source_category_id' in query && Number.isInteger(Number(query.source_category_id))
  return (checkIfRegionCategoriesPage(routeName) || checkIfRegionThemesPage(routeName)) && hasSourceCategoryId
}

export function checkIfRegionHomePage(routeName?: RouteRecordName | null) {
  return !!(routeName?.toString().startsWith('index__') || routeName?.toString().startsWith('regions-rid___'))
}
